// extracted by mini-css-extract-plugin
export default {"category":"styles_category__wk8Cy","imageContainer":"styles_imageContainer__8UWk0","image":"styles_image__7TUJ3","borderBottom":"styles_borderBottom__G0bOw"};